module.exports = __webpack_public_path__ + "img/faq-ask-form.png";